import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useLang } from "../context/LanguageContext";
import { Calendar, Clock, MapPin, Users, ArrowRight } from "lucide-react";
import Seo from "../components/Seo";

const Workshops = () => {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/public/workshops").then(r => setItems(r.data)); }, []);

  const statusBadge = (s) => {
    const m = { open: ["bg-primary/15 text-primary border-primary/30", t("workshop.open")],
                full: ["bg-destructive/15 text-destructive border-destructive/30", t("workshop.full")],
                closed: ["bg-muted text-muted-foreground border-border", t("workshop.closed")] };
    const [cls, lab] = m[s] || m.open;
    return <span className={`text-[10px] uppercase tracking-[0.2em] px-2.5 py-1 rounded-full border ${cls}`}>{lab}</span>;
  };

  return (
    <div data-testid="workshops-page">
      <Seo
        title="Tamilische Musik- & Tanz-Workshops in Wil SG"
        description="Intensiv-Workshops und Schnupperkurse für tamilische Musik und Tanz – Mirudangam, Bollywood, Kuthu und mehr. Anmeldung direkt online."
        path="/workshops"
        keywords="Tamilische Musikworkshops, Tamilische Tanzkurse, Mirudangam Workshop, Bollywood Workshop, Kuthu Workshop"
      />
      <section className="py-20 max-w-7xl mx-auto px-6">
        <div className="text-xs uppercase tracking-[0.3em] text-primary mb-4">{t("nav.workshops")}</div>
        <h1 className="font-serif-display text-5xl md:text-6xl leading-[1.05] max-w-3xl mb-12">{t("home.workshopsTitle")}</h1>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((w) => (
            <div key={w.id} className="card-academy rounded-lg overflow-hidden flex flex-col">
              <div className="aspect-video overflow-hidden">
                <img src={w.image} alt={w.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex items-center justify-between mb-3">
                  {statusBadge(w.status)}
                  <div className="text-xs text-muted-foreground">{w.language}</div>
                </div>
                <div className="font-serif-display text-2xl mb-2">{w.title}</div>
                <p className="text-sm text-muted-foreground mb-4 line-clamp-3">{w.description}</p>
                <div className="space-y-2 text-xs text-muted-foreground mb-5">
                  <div className="flex items-center gap-2"><Calendar className="w-3.5 h-3.5 text-primary" />{w.date}</div>
                  <div className="flex items-center gap-2"><Clock className="w-3.5 h-3.5 text-primary" />{w.time}</div>
                  <div className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5 text-primary" />{w.location}</div>
                  <div className="flex items-center gap-2"><Users className="w-3.5 h-3.5 text-primary" />Max. {w.max_participants}</div>
                </div>
                <div className="flex items-center justify-between mt-auto">
                  <div className="text-primary font-medium">CHF {w.price}</div>
                  <Link to={`/anmeldung?course=${encodeURIComponent(w.title)}&category=workshop`} className="inline-flex items-center gap-2 text-sm text-primary hover:gap-3 transition-all">
                    {t("cta.enrollNow")} <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Workshops;
